import React, { useState } from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import { useAuth } from '@templatean/shared/hooks'
import { storageService } from '@templatean/shared/services'

const SettingsPage: React.FC = () => {
  const { user, logout } = useAuth()
  const [preferences, setPreferences] = useState({
    defaultTheme: 'modern',
    autoSave: true,
    showSpeakerNotes: true,
    slideTransition: 'fade',
    presentationDuration: 20,
    aiTone: 'professional'
  })

  const handleSavePreferences = async () => {
    await storageService.saveUserPreferences(preferences)
    alert('Preferences saved!')
  }

  const handleLogout = async () => {
    if (confirm('Are you sure you want to sign out?')) {
      await logout()
    }
  }

  return (
    <AppContainer>
      <Header 
        title="Settings"
        subtitle="Configure your PowerPoint add-in preferences"
      />
      
      <div className="page-content settings-page">
        <section className="settings-section">
          <h2>Account</h2>
          <div className="settings-info">
            <p><strong>Name:</strong> {user?.fullName}</p>
            <p><strong>Email:</strong> {user?.email}</p>
            <p><strong>Tenant:</strong> {user?.tenantId}</p>
          </div>
          <button onClick={handleLogout} className="btn btn-secondary">
            Sign Out
          </button>
        </section>

        <section className="settings-section">
          <h2>Presentation Preferences</h2>
          
          <div className="preference-item">
            <label>
              Default Theme:
              <select
                value={preferences.defaultTheme}
                onChange={(e) => setPreferences({
                  ...preferences,
                  defaultTheme: e.target.value
                })}
                className="preference-select"
              >
                <option value="modern">Modern</option>
                <option value="corporate">Corporate</option>
                <option value="creative">Creative</option>
                <option value="minimal">Minimal</option>
                <option value="tech">Tech</option>
              </select>
            </label>
          </div>

          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.autoSave}
                onChange={(e) => setPreferences({
                  ...preferences,
                  autoSave: e.target.checked
                })}
              />
              <span>Auto-save presentations</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              <input
                type="checkbox"
                checked={preferences.showSpeakerNotes}
                onChange={(e) => setPreferences({
                  ...preferences,
                  showSpeakerNotes: e.target.checked
                })}
              />
              <span>Generate speaker notes with AI</span>
            </label>
          </div>

          <div className="preference-item">
            <label>
              Default Slide Transition:
              <select
                value={preferences.slideTransition}
                onChange={(e) => setPreferences({
                  ...preferences,
                  slideTransition: e.target.value
                })}
                className="preference-select"
              >
                <option value="none">None</option>
                <option value="fade">Fade</option>
                <option value="push">Push</option>
                <option value="wipe">Wipe</option>
                <option value="split">Split</option>
              </select>
            </label>
          </div>

          <div className="preference-item">
            <label>
              Default Presentation Duration (minutes):
              <input
                type="number"
                min="5"
                max="60"
                value={preferences.presentationDuration}
                onChange={(e) => setPreferences({
                  ...preferences,
                  presentationDuration: parseInt(e.target.value)
                })}
                className="preference-input"
              />
            </label>
          </div>

          <div className="preference-item">
            <label>
              AI Content Tone:
              <select
                value={preferences.aiTone}
                onChange={(e) => setPreferences({
                  ...preferences,
                  aiTone: e.target.value
                })}
                className="preference-select"
              >
                <option value="professional">Professional</option>
                <option value="casual">Casual</option>
                <option value="persuasive">Persuasive</option>
                <option value="informative">Informative</option>
                <option value="inspirational">Inspirational</option>
              </select>
            </label>
          </div>

          <button onClick={handleSavePreferences} className="btn btn-primary">
            Save Preferences
          </button>
        </section>

        <section className="settings-section">
          <h2>About</h2>
          <p>Templatean for PowerPoint v1.0.0</p>
          <p>© 2024 Templatean Corporation</p>
          <p>
            <a href="https://templatean.com/help/powerpoint" target="_blank">
              Help & Documentation
            </a>
          </p>
        </section>
      </div>
    </AppContainer>
  )
}

export default SettingsPage